function parseData(data) {
  if ((!data) || data.length == 0) {
    return null;
  } else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {

  const cashAccountDetails = ({ bookingParam, metaData }) =>
    api.getCashAccountbookings(bookingParam, metaData)
      .then(parseData)

  const getRTCashAccList = ({ inputParam, metaData }) =>
    api.getRTCashAccList(inputParam, metaData)
      .then(parseData)

  return {
    cashAccountDetails,
    getRTCashAccList
  };

}

module.exports = serviceFactory;